<template>
      <div id="checklist-new">
            <section class="section intro-hero animate__animated animate__fadeIn">
                  <BackButton link="/welcome-to-anthem" />
                  <div class="grid-container max">
                        <div class="intro-hero-grid">
                              <div class="intro-hero-left">
                                    <h1>Your checklist<br />for 2027</h1>
                                    <p class="checklist-subhead">This year, the Open Enrollment selection period is October 19 &ndash; November 6, 2026.</p>
                              </div>
                              <div class="intro-hero-right">
                                    <p class="checklist-intro">If you don&rsquo;t want to make any changes to your current Anthem plan option and tier, your plan will automatically roll over for 2027.</p>
                                    <div class="checklist-steps">
                                          <div class="checklist-step">
                                                <div class="checklist-step-marker"><span>1</span></div>
                                                <p><strong>Check</strong> monthly premium rates for Plan Options at <a href="https://shbp.georgia.gov" target="_blank" @click="track('Link', 'shbp.georgia.gov - Checklist')">shbp.georgia.gov</a> to see your monthly payment.</p>
                                          </div>
                                          <div class="checklist-step">
                                                <div class="checklist-step-marker"><span>2</span></div>
                                                <p><strong>Review</strong> the information in this guide to compare Anthem&rsquo;s Plan Options. If you need assistance, use the enrollment resources available at <a href="https://anthem.com/shbp" target="_blank" @click="track('Link', 'anthem.com/shbp - Checklist')">anthem.com/shbp</a>.</p>
                                          </div>
                                          <div class="checklist-step">
                                                <div class="checklist-step-marker"><span>3</span></div>
                                                <p><strong>Log-in</strong> to <a href="https://mySHBPga.adp.com" target="_blank" @click="track('Link', 'mySHBPga.adp.com - Checklist')">mySHBPga.adp.com</a> to select your Plan Option and tier during the selection period if you want to make a change.</p>
                                          </div>
                                    </div>
                              </div>
                        </div>
                  </div>
                  <div class="intro-hero-btn-wrap">
                        <router-link to="/choose-plan" class="intro-hero-btn"><span>Next</span></router-link>
                  </div>
            </section>
      </div>
</template>

<script>
      import BackButton from "../components/BackButton"
      import gaEventMixin from "../mixins/gaEventMixin"
      export default {
            name: "SHBPChecklist",
            mounted() {
                  window.scrollTo(0, 0)
            },
            components: {
                  BackButton
            },
            mixins: [gaEventMixin]
      }
</script>

<style lang="scss">
#checklist-new {
      .intro-hero {
            background-color: #ffffff;
            margin-top: 68px;
            padding: 120px 0 100px 0;
            position: relative;
            min-height: calc(100vh - 68px);
            display: flex;
            flex-direction: column;
            justify-content: center;

            .back-btn {
                  left: 86px;
                  border-color: #1254E8;

                  &::before {
                        background-image: none;
                        background-color: #1254E8;
                        filter: none;
                        -webkit-mask-image: url("~@/assets/img/arrow-left-icon.png");
                        mask-image: url("~@/assets/img/arrow-left-icon.png");
                        -webkit-mask-size: 15px 13px;
                        mask-size: 15px 13px;
                        -webkit-mask-repeat: no-repeat;
                        mask-repeat: no-repeat;
                        -webkit-mask-position: center;
                        mask-position: center;
                  }
            }

            .grid-container.max {
                  width: 100%;
                  max-width: 85rem !important;
            }

            .intro-hero-grid {
                  display: flex;
                  flex-wrap: wrap;
                  align-items: center;
                  justify-content: space-between;
                  gap: 40px;
            }

            .intro-hero-left {
                  flex: 1 1 480px;
                  max-width: 640px;

                  h1 {
                        color: #1355E9;
                        font-size: clamp(4.25rem, 6.5vw, 5.25rem) !important;
                        font-weight: 600;
                        line-height: 1 !important;
                        margin-bottom: 0;
                  }

                  .checklist-subhead {
                        color: #012E58;
                        font-size: 1.25rem;
                        font-weight: 600;
                        line-height: 1.4;
                        margin-top: 24px;
                        margin-bottom: 0;
                  }
            }

            .intro-hero-right {
                  flex: 1 1 360px;
                  max-width: 460px;

                  .checklist-intro {
                        color: #012E58;
                        font-size: 1.125rem;
                        font-weight: 600;
                        line-height: 1.4;
                        margin-bottom: 32px;
                  }

                  .checklist-steps {
                        position: relative;
                  }

                  .checklist-step {
                        position: relative;
                        display: flex;
                        gap: 16px;
                        padding-bottom: 32px;

                        &::before {
                              content: "";
                              position: absolute;
                              top: 28px;
                              bottom: 0;
                              left: 13px;
                              width: 2px;
                              background-color: #1355E9;
                        }

                        &:last-child {
                              padding-bottom: 0;

                              &::before {
                                    display: none;
                              }
                        }
                  }

                  .checklist-step-marker {
                        position: relative;
                        z-index: 1;
                        flex-shrink: 0;
                        width: 28px;
                        height: 28px;
                        border-radius: 50%;
                        border: solid 2px #1355E9;
                        background-color: #ffffff;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: #1355E9;
                        font-weight: 700;
                        font-size: 0.875rem;
                  }

                  .checklist-step p {
                        color: #12130f;
                        font-size: 1rem;
                        line-height: 1.5;
                        margin-bottom: 0;
                        padding-top: 2px;

                        strong {
                              color: #1355E9;
                        }

                        a {
                              color: #1355E9;
                              font-weight: 700;
                              text-decoration: underline;
                        }
                  }
            }

            .intro-hero-btn-wrap {
                  position: fixed;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  z-index: 3;
                  background-color: #ffffff;
                  box-shadow: 0px -3px 4px rgba(0, 0, 0, 0.10);
                  padding: 20px 0;
                  text-align: center;
            }

            .intro-hero-btn {
                  display: block;
                  background-color: #1355E9;
                  color: #ffffff !important;
                  font-weight: 700;
                  text-transform: uppercase;
                  font-size: 1rem;
                  padding: 18px 0;
                  width: 100%;
                  max-width: 330px;
                  text-align: center;
                  border-radius: 30px;
                  border: none;
                  cursor: pointer;
                  margin: 0 auto;

                  &:hover {
                        background-color: #44B8F3;
                  }
            }

            @media only screen and (max-width: 959px) {
                  padding: 96px 24px 100px 24px;
                  justify-content: flex-start;

                  .back-btn {
                        left: 2rem;
                  }

                  .intro-hero-grid {
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 0;
                  }

                  .intro-hero-left {
                        flex: 0 0 auto;
                        max-width: 100%;

                        h1 {
                              font-size: clamp(2rem, 11vw, 5.25rem) !important;
                        }
                  }

                  .intro-hero-right {
                        flex: 0 0 auto;
                        width: 100%;
                        max-width: 100%;
                        margin-top: 40px;

                        .checklist-intro {
                              font-size: 1rem;
                        }
                  }
            }
      }
}
</style>
